<template>
  <div class="suggestions-wrapper">
    <div class="suggestions-title">{{ TEXT.title }}</div>
    <div class="suggestions-container">
      <div v-for="(suggestion, idx) in SUGGESTIONS" :key="idx" class="suggestion-card" @click="handleClick(suggestion)">
        <span class="suggestion-text">{{ suggestion }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n-composable'

const { t } = useI18n()

const emit = defineEmits(['suggestion-selected'])

const TEXT = {
  title: t('components.search_advance_ia.more_suggestions')
}

const SUGGESTIONS = [
  '¿Hay plazos o fechas clave que vencen?',
  'Dame toda la información sobre las costas',
  '¿Qué recursos se han interpuesto en este expediente?',
  '¿Qué argumentos tiene la parte contraria?'
]

const handleClick = (suggestion: string) => {
  emit('suggestion-selected', suggestion)
}
</script>

<style lang="scss" scoped>
.suggestions-wrapper {
  width: 100%;
}

.suggestions-title {
  color: $neutral-grey-800;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  padding-bottom: $spacing-md;
}

.suggestions-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: $spacing-md;
  width: 100%;
}

.suggestion-card {
  background: $neutral-grey-100;
  border-radius: 8px;
  padding: $spacing-md;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: flex-start;
  gap: $spacing-xs;

  .suggestion-text {
    color: $neutral-grey-700;
    font-family: $inter-font;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    flex: 1;
  }
}
</style>
